import { Divider, Tag } from 'antd';
import { TextBold } from 'components/ui/base/typography';
import { Fragment } from 'react';
import DeclarationErrorCard from './DeclarationErrorCard';
import { CardsHeader, SectionCards, SectionHeader } from './DeclarationErrorCard.styles';
import { ErrorCardSection } from './groupErrorCardsByItem';
import { ErrorCard, ErrorCardField } from './types';

interface Props<TError> {
    sections: ErrorCardSection<TError>[];
    onGoToField: (field: ErrorCardField, card: ErrorCard<TError>) => void;
    onShowDetails: (error: TError) => void;
}

const pluralizeErrors = (count: number) => `${count} ${count === 1 ? 'error' : 'errors'}`;

const ErrorCountTag = ({ count }: { count: number }) => (
    <Tag color="error" style={{ borderRadius: 999, marginRight: 0 }}>
        {pluralizeErrors(count)}
    </Tag>
);

const DeclarationErrorCards = <TError,>({ sections, onGoToField, onShowDetails }: Props<TError>) => {
    const errorCount = sections.reduce((count, section) => count + section.cards.length, 0);

    return (
        <>
            <CardsHeader>
                <ErrorCountTag count={errorCount} />
            </CardsHeader>

            {sections.map((section) => (
                <Fragment key={section.title}>
                    <Divider style={{ margin: '1.6rem 0' }} />
                    <SectionHeader>
                        <TextBold>{section.title}</TextBold>
                        <ErrorCountTag count={section.cards.length} />
                    </SectionHeader>
                    <SectionCards>
                        {section.cards.map(({ card, number }) => (
                            <DeclarationErrorCard
                                key={number}
                                card={card}
                                number={number}
                                onGoToField={(field) => onGoToField(field, card)}
                                onShowDetails={() => onShowDetails(card.error)}
                            />
                        ))}
                    </SectionCards>
                </Fragment>
            ))}
        </>
    );
};

export default DeclarationErrorCards;
